import { FC, useCallback } from "react";
import { SelectChangeEvent } from "@mui/material";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { normalizedCostWidgetSetupForecastSelector } from "@/store/dashboards/selectors/setups/normalized-cost-widget/normalizedCostWidgetSetupForecastSelector";

import { normalizedCostWidgetSetupForecastedOptionsSelector } from "@/store/dashboards/selectors/widgets/normalized-cost-widget/setup/normalizedCostWidgetSetupForecastedOptionsSelector";
import { normalizedCostWidgetSetupDataChangeThunk } from "@/store/dashboards/thunks/widgets/normalized-cost-widget/setup-change/normalizedCostWidgetSetupDataChangeThunk";
import { ForecastOption } from "@/services/cloudchipr.api";
import { WidgetForecastSelect } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/common/toolbar/WidgetForecastSelect";

export const NormalizedCostWidgetForecastSelect: FC = () => {
  const dispatch = useAppDispatch();
  const forecast = useAppSelector(normalizedCostWidgetSetupForecastSelector);

  const forecastedCostsOptions = useAppSelector(
    normalizedCostWidgetSetupForecastedOptionsSelector,
  );

  const changeHandler = useCallback(
    (event: SelectChangeEvent<ForecastOption | null>) => {
      const forecastOption = event.target.value as ForecastOption;

      if (!forecastOption) {
        return;
      }

      dispatch(normalizedCostWidgetSetupDataChangeThunk({ forecastOption }));
    },
    [dispatch],
  );

  return (
    <WidgetForecastSelect
      forecast={forecast ?? "month"}
      onChange={changeHandler}
      options={forecastedCostsOptions}
    />
  );
};
